import { render, staticRenderFns } from "./Shops.vue?vue&type=template&id=07269cec&scoped=true&"
import script from "./Shops.vue?vue&type=script&lang=js&"
export * from "./Shops.vue?vue&type=script&lang=js&"
import style0 from "./Shops.vue?vue&type=style&index=0&id=07269cec&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07269cec",
  null
  
)

export default component.exports